<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Empréstimo
            <Modal
              :tipoSelecao="'ferramentaria'"
              :desativarGrupo="true"
              :desativarSubGrupo="true"
              :desativarDataEntrada="true"
              :desativarDataSaida="true"
              :desativarDocumentoEntrada="true"
              :desativarDocumentoSaida="true"
              :desativarFornecedor="true"
              :desativarNumero="true"
              :origimIsMultiple="true"
              :desativarFornecedorSelect="true"
              :desativarTipoMovimento="true"
              :desativarNtransferencia="true"
              :filtroEmprestimoAberto="true"
              @unidade="getAtivos"
              :loadingValue="loadingValue"
              :dataDisable="true"
              :desativarStatus="true"
              :classUnidade="'col-6'"
              :classCodigo="'col-5'"
              :classDescricao="'col-6'"
              :classTempo="'col-6'"
              :classCentro="'col-5'"
              :classOrigem="'col-6'"
              :classSolicitante="'col-5'"
              :classDataInicial="'col-6'"
              :classDataFinal="'col-5'"
              :classEmprestimoAberto="'col-6'"
              :classPatrimonio="'col-5'"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :exportName="'Empréstimo'"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'ferramentaria-relatorio-emprestimo'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
    <q-dialog persistent v-model="showComentarioMovimentacao">
      <q-card style="height: 220px; width: 450px">
        <q-card-section class="column">
          <span style="color: #21324a" class="mensagem-text">Aviso</span>
          <q-separator style="height: 1px; background-color: #21324a" />
        </q-card-section>

        <q-card-section style="min-height: 70px">
          <span style="color: #21324a">
            Seu relatório excedeu o tempo para geração automático, aguarde o
            link na central de notificações pra download do relatório
            completo.</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            label="Confirmar"
            :disabled="desabilitarConfirme"
            no-caps
            icon="done"
            @click="openModal++"
            v-close-popup
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              font-weight: normal;
            "
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Modal from "../components/ModalFerramentaria.vue";
import Flexmonster from "../../relatorios/components/Flexmonster.vue";
import { useQuasar } from "quasar";
export default {
  components: { Flexmonster, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();
    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref({
      Codigo: {
        type: "string",
      },
      Descrição: {
        type: "string",
      },
      "Matricula Solicitante": {
        type: "string",
      },
      Patrimonio: {
        type: "string",
      },
      "Matricula Almoxarife": {
        type: "string",
      },
      "Data Devolução": {
        type: "date string",
      },
      "Retorno Esperado": {
        type: "date string",
      },
      "Data Retirada": {
        type: "date string",
      },
      "Comentario Retirada": {
        type: "string",
      },
      "Comentario Devolução": {
        type: "string",
      },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const showComentarioMovimentacao = ref(false);
    const filtrosObject = ref(null);

    const getAtivos = async (data, value) => {
      try {
        filtrosObject.value = {
          codigo: value.codigo != "" ? value.codigo : undefined,
          dataRetirada:
            value.dataRetirada != ""
              ? value.dataRetirada.split("/").reverse().join("-")
              : undefined,
          dataDevolucao: value.dataDevolucao
            ? value.dataDevolucao.split("/").reverse().join("-")
            : undefined,
          solicitante: value.solicitante != "" ? value.solicitante : undefined,
          unidade: value.unidade.id,
          descricao: value.descricao != "" ? value.descricao : undefined,
          abertos: value.emprestimoEmAberto?.value,
          tempoExcedido: value.tempo.value,
          origem: value.origem.length != 0 ? value.origem.join(",") : undefined,
          patrimonio: value.patrimonio != "" ? value.patrimonio : undefined,
          centroCusto:
            value?.centro
              ?.map((value) => {
                return value.id;
              })
              ?.join(",") != ""
              ? value?.centro
                  ?.map((value) => {
                    return value.id;
                  })
                  ?.join(",")
              : undefined,
        };

        loadingValue.value = true;

        const response = await store.dispatch(
          "ferramentaria/relatorioEmprestimo",
          {
            codigo: value.codigo != "" ? value.codigo : undefined,
            dataRetirada:
              value.dataRetirada != ""
                ? value.dataRetirada.split("/").reverse().join("-")
                : undefined,
            dataDevolucao: value.dataDevolucao
              ? value.dataDevolucao.split("/").reverse().join("-")
              : undefined,
            solicitante:
              value.solicitante != "" ? value.solicitante : undefined,
            unidade: value.unidade.id,
            descricao: value.descricao != "" ? value.descricao : undefined,
            abertos: value.emprestimoEmAberto?.value,
            tempoExcedido: value.tempo.value,
            origem:
              value.origem.length != 0 ? value.origem.join(",") : undefined,
            patrimonio: value.patrimonio != "" ? value.patrimonio : undefined,
            centroCusto:
              value?.centro
                ?.map((value) => {
                  return value.id;
                })
                ?.join(",") != ""
                ? value?.centro
                    ?.map((value) => {
                      return value.id;
                    })
                    ?.join(",")
                : undefined,
          }
        );

        link.value = response.data.resultado.dados;
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        loadingValue.value = false;
        if (error?.response?.status == undefined) {
          showComentarioMovimentacao.value = !showComentarioMovimentacao.value;
          getRelatorioSecundario();
        }
      }
    };

    const getRelatorioSecundario = async () => {
      loadingValue.value = true;

      const response = await store.dispatch(
        "ferramentaria/relatorioEmprestimo",
        {
          origem: filtrosObject.value.origem,
          codigo: filtrosObject.value.codigo,
          dataRetirada: filtrosObject.value.dataRetirada,
          dataDevolucao: filtrosObject.value.dataDevolucao,
          solicitante: filtrosObject.value.solicitante,
          unidade: filtrosObject.value.unidade,
          descricao: filtrosObject.value.descricao,
          abertos: filtrosObject.value.abertos,
          tempoExcedido: filtrosObject.value.tempoExcedido,
          centroCusto: filtrosObject.value.centroCusto,
          patrimonio: filtrosObject.value.patrimonio,
          background: 1,
        }
      );

      link.value = response.data.resultado.dados;
      updateLink.value++;
      loadingValue.value = false;
      exibir.value = true;
      url.value = response?.request?.responseURL;
    };
    const relatorioLink = route.query.id;
    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        if (JSON.parse(id).indexOf("atv") != -1) {
          quasar.loading.show();
          loadingValue.value = true;
          const response = await store.dispatch(
            "ferramentaria/relatorioEmprestimoNotificacao",
            {
              url: JSON.parse(id),
            }
          );

          link.value = response.data.resultado.dados;
          updateLink.value++;
          loadingValue.value = false;

          exibir.value = true;
          url.value = response?.request?.responseURL;
          quasar.loading.hide();
          return;
        }

        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        relatorioLink != "" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.resultado.dados;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getAtivos,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      filtros,
      showTotals,
      id,
      getRelatorioSalvo,
      formats,
      loadingStop,
      verificarUrl,
      url,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
      showComentarioMovimentacao,
      filtrosObject,
    };
  },
};
</script>
